import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AdsCompaignsComponent } from "./ads-compaigns/ads-compaigns.component";
import { AdvertisersComponent } from "./advertisers/advertisers.component";
import { CalendarComponent } from "./ads-compaigns/calendar/calendar.component";
import { ConsumersComponent } from "./consumers/consumers.component";
import { LocationPartnersComponent } from "./location-partners/location-partners.component";
import { MainComponent } from "./main/main.component";
import { CreateRouterStepperComponent } from "./router/create-router-stepper/create-router-stepper.component";
import { RouterComponent } from "./router/router.component";
import { PaymentComponent } from "./location-partners/payment/payment.component";
import { CampagnesLPComponent } from "./location-partners/campagnes-lp/campagnes-lp.component";
import { CalculatorComponent } from "./ads-compaigns/calculator/calculator.component";
import { BugReportComponent } from "src/app/shared/components/bug-report/bug-report.component";
import { AdStatisticsComponent } from "../advertiser/insights/ad-statistics/ad-statistics.component";
import { LocationStatisticsComponent } from "./location-partners/location-statistics/location-statistics.component";
import { DetailsDiscutionSupportComponent } from "src/app/shared/components/bug-report/details-discution-support/details-discution-support.component";
import { ProfileComponent } from "src/app/shared/components/profile/profile.component";
import { EstimatesComponent } from "./advertisers/estimates/estimates.component";
import { InvoicesComponent } from "./advertisers/invoices/invoices.component";
import { LoggerComponent } from "./logger/logger.component";
import { authGuard } from "src/app/shared/services/guard/auth-guard.service";
import { FranchiseListComponent } from "./location-partners/franchise-list/franchise-list.component";
import { FranchiseStatisticsComponent } from "./location-partners/franchise-list/franchise-statistics/franchise-statistics.component";
import { AdvertisingCampaignComponent } from "../advertiser/advertising-campaign/advertising-campaign.component";
import { NewCampaignComponent } from "../advertiser/advertising-campaign/new-campaign/new-campaign.component";
import { PaymentSuccessComponent } from "../advertiser/advertising-campaign/payment/payment-success/payment-success.component";
import { PaymentCancelComponent } from "../advertiser/advertising-campaign/payment/payment-cancel/payment-cancel.component";

var routingAnimation = localStorage.getItem("animate");

const routes: Routes = [
  {
    path: "",
    redirectTo: "main",
    pathMatch: "full",
  },
  {
    path: "main",
    component: MainComponent,
    canActivate: [authGuard],
    data: {
      animation: [routingAnimation],
      title: "Main page | Relead ",
      description: " ",
    },
  },
  {
    path: "location-partners/repository",
    component: LocationPartnersComponent,
    canActivate: [authGuard],
    data: {
      animation: [routingAnimation],
      title: "Location partners list | Relead ",
    },
  },
  {
    path: "location-partners/franchises",
    component: FranchiseListComponent,
    canActivate: [authGuard],
    data: {
      animation: [routingAnimation],
      title: "Location partners list | Relead ",
    },
  },
  {
    path: "location-partners/repository/statistics",
    component: LocationStatisticsComponent,
    canActivate: [authGuard],
    data: {
      animation: [routingAnimation],
      title: "Location partner statistics | Relead ",
      queryParams: {
        title: "companyName",
      },
    },
  },
  {
    path: "location-partners/payment",
    component: PaymentComponent,
    canActivate: [authGuard],
    data: {
      animation: [routingAnimation],
      title: "payments list | Relead ",
    },
  },
  {
    path: "location-partners/campagnes",
    component: CampagnesLPComponent,
    canActivate: [authGuard],
    data: {
      animation: [routingAnimation],
      title: "Location partners campaigns list | Relead ",
    },
  },
  {
    path: "location-partners/campagnes/statistics/:campaignHasedID",
    component: AdStatisticsComponent,
    canActivate: [authGuard],
    data: {
      animation: [routingAnimation],
    },
  },
  {
    path: "routers/:status",
    component: RouterComponent,
    canActivate: [authGuard],
    data: {
      animation: [routingAnimation],
      title: "Routers list | Relead ",
    },
  },
  {
    path: "routers/create",
    canActivate: [authGuard],
    component: CreateRouterStepperComponent,
  },
  {
    path: "routers/update/:mac",
    canActivate: [authGuard],
    component: CreateRouterStepperComponent,
  },
  {
    path: "consumers",
    canActivate: [authGuard],
    component: ConsumersComponent,
    data: {
      animation: [routingAnimation],
      title: "Consumers | Relead ",
    },
  },
  {
    path: "settings",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./settings/admin-settings.module").then(
        (m) => m.AdminSettingsModule
      ),
  },
  {
    path: "advertisers/repository",
    canActivate: [authGuard],
    component: AdvertisersComponent,
    data: {
      animation: [routingAnimation],
      title: "Advertisers list | Relead ",
    },
  },
  {
    path: "advertisers/commandes",
    canActivate: [authGuard],
    component: EstimatesComponent,
    data: {
      animation: [routingAnimation],
      title: "Estimates list | Relead ",
    },
  },
  {
    path: "advertisers/factures",
    canActivate: [authGuard],
    component: InvoicesComponent,
    data: {
      animation: [routingAnimation],
      title: "Invoices list | Relead ",
    },
  },
  {
    path: "campaigns/pipeline",
    canActivate: [authGuard],
    component: AdsCompaignsComponent,
    data: {
      animation: [routingAnimation],
      title: "Advertising campaigns list | Relead ",
    },
  },
  {
    path: "campaigns/pipeline/statistics/:campaignHasedID",
    canActivate: [authGuard],
    component: AdStatisticsComponent,
    data: {
      animation: [routingAnimation],
    },
  },
  {
    path: "campaigns/simulateur",
    canActivate: [authGuard],
    component: CalculatorComponent,
    data: {
      animation: [routingAnimation],
      title: "Calculator | Relead ",
    },
  },
  {
    path: "campaigns/calendar",
    canActivate: [authGuard],
    component: CalendarComponent,
    data: {
      animation: [routingAnimation],
      title: "Calendar | Relead ",
    },
  },
  {
    path: "support/:status",
    canActivate: [authGuard],
    component: BugReportComponent,
    data: {
      title: "Support | Relead ",
    },
  },
  {
    path: "support-details",
    canActivate: [authGuard],
    component: DetailsDiscutionSupportComponent,
    data: {
      queryParams: {
        ref: "ref",
      },
      animation: [routingAnimation],
      title: "See the details of the discussion | Relead  ",
    },
  },
  {
    path: "profile",
    canActivate: [authGuard],
    component: ProfileComponent,
    data: {
      animation: [routingAnimation],
      title: "Company information | Relead ",
    },
  },
  {
    path: "user-history",
    canActivate: [authGuard],
    component: LoggerComponent,
    data: {
      animation: [routingAnimation],
      title: "User History | Relead ",
    },
  },
  {
    path: "location-partners/franchise/statistics",
    component: FranchiseStatisticsComponent,
    canActivate: [authGuard],
    data: {
      animation: [routingAnimation],
      title: "Franchise statistics | Relead ",
      queryParams: {
        title: "companyName",
      },
    },
  },

  {
    path: "advertising-campaigns/create-ad",
    component: AdvertisingCampaignComponent,
    data: {
      animation: [routingAnimation],
      title: "Add new campaign | Relead ",
    },
  },
  {
    path: "advertising-campaigns/create-ad/:objective",
    component: NewCampaignComponent,
    data: {
      animation: [routingAnimation],
      title: "Add new campaign | Relead ",
    },
  },

  {
    path: "advertising-campaigns/payment-success",
    component: PaymentSuccessComponent,
    data: {
      animation: [routingAnimation],
    },
  },
  {
    path: "advertising-campaigns/payment-cancel",
    component: PaymentCancelComponent,
    data: {
      animation: [routingAnimation],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
